"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const CoreRenderState_1 = require("../../tree/core/CoreRenderState");
class C2dCoreRenderState extends CoreRenderState_1.CoreRenderState {
    isRenderTextureReusable(renderTextureInfo) {
        return false;
    }
    finishRenderState() {
        // Noop
    }
    addQuad(texture, elementCore) {
        const index = this.length;
        // Render context changes while traversing so we save it by ref.
        const quadList = this.quadList;
        quadList.add(texture, elementCore);
        quadList.setRenderContext(index, elementCore.getRenderContext());
        quadList.setWhite(index, elementCore.isWhite());
        quadList.setSimpleTc(index, elementCore.hasSimpleTexCoords());
    }
}
exports.C2dCoreRenderState = C2dCoreRenderState;
//# sourceMappingURL=C2dCoreRenderState.js.map